var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChairlift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lineElement lineImg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-cl-1{fill:#008849;}.cls-cl-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grafika"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-cl-1",
    d: "M106.29,0A106.3,106.3,0,1,0,212.6,106.3,106.42,106.42,0,0,0,106.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4117",
    className: "cls-cl-2",
    d: "M114,77.63a9.92,9.92,0,1,1-9.92,9.91A9.94,9.94,0,0,1,114,77.63h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4119",
    className: "cls-cl-2",
    d: "M77.23,34.09a9.92,9.92,0,1,1-5.94,12.72,9.93,9.93,0,0,1,5.94-12.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4119-2",
    className: "cls-cl-2",
    d: "M100.72,25.54a9.92,9.92,0,1,1-5.94,12.72,9.94,9.94,0,0,1,5.94-12.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-cl-2",
    d: "M147.78,144.78l-22.51-1.54,1.86-30.71c.39-6.54-5.77-10.62-11.85-10.71l-1.23,0c-6.68-.11-13.09,4.53-13.09,11.53v28l.1,10.31c0,4.17,4.45,5.76,8.1,5.76h32.42l1.6,33.83a91.25,91.25,0,0,0,8.9-4.46l1.91-35A6.59,6.59,0,0,0,147.78,144.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-cl-2",
    d: "M92.34,60.22v92.15a12.42,12.42,0,0,0,12.4,12.4h32.83a2.48,2.48,0,1,0,0-5H104.74a7.45,7.45,0,0,1-7.44-7.44V58.42l67-24.4q-2.29-1.86-4.72-3.56l-142.9,52c-.5,1.9-1,3.82-1.33,5.76Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairlift);
export default __webpack_public_path__ + "static/media/chairlift.61f3a2c585cf79fc7568891eb20a3a47.svg";
export { ForwardRef as ReactComponent };